export default __webpack_public_path__ + "static/media/dev-net.b804a316.png";